import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
    headerRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
    },
}));
